import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
import { SearchWrapper as SearchWrapperOrigin } from 'themes/views/layouts'
// components
import { Scrollbar } from 'components/UI'
// icons
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'

export const FieldsWrapper = styled(Scrollbar)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100% - 130px);
`

export const FieldWrapper = styled.div`
  cursor: pointer;

  &:hover {
    font-weight: bold;
  }
`

export const IconWrapper = styled.div`
  margin-left: -4px;
  height: 24px;
  margin-bottom: 12px;

  svg {
    cursor: pointer;
  }
`

export const SearchWrapper = styled(SearchWrapperOrigin)`
  align-items: center;
  background: ${colors.white};
  border: 2px solid ${colors.purple500};
  border-radius: 6px;
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 20px;
  width: inherit;

  div:nth-child(2) {
    margin: 0 16px 0 45px;
  }
`

export const ArrowIcon = styled(ArrowRightAltIcon)`
  transform: rotate(180deg);
`
